export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#F5F5F0] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/0507426ac8a76264b390c2066348759a/94c66b4f7327e925b3b27ba3bf8105ac.jpeg" 
                alt="Adriana Muñoz" 
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <h3 className="font-semibold text-gray-900 font-['Playfair_Display']">Adriana Muñoz</h3>
                <p className="text-sm text-gray-600">Psicóloga Profesional</p>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">
              Dedicada a ayudar a las personas a alcanzar su bienestar emocional y crecimiento personal a través de terapia profesional y empática.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <a href="#servicios" className="text-sm text-gray-600 hover:text-[#14B8A6] transition-colors cursor-pointer">
                  Servicios
                </a>
              </li>
              <li>
                <a href="#testimonios" className="text-sm text-gray-600 hover:text-[#14B8A6] transition-colors cursor-pointer">
                  Testimonios
                </a>
              </li>
              <li>
                <a href="#contacto" className="text-sm text-gray-600 hover:text-[#14B8A6] transition-colors cursor-pointer">
                  Contacto
                </a>
              </li>
              <li>
                <a 
                  href="https://wa.me/1234567890" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-[#14B8A6] transition-colors cursor-pointer"
                >
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-whatsapp-line text-lg text-[#14B8A6]"></i>
                <a 
                  href="https://wa.me/1234567890" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-[#14B8A6] transition-colors cursor-pointer"
                >
                  +52 6692612777
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-mail-line text-lg text-[#14B8A6]"></i>
                <a 
                  href="mailto:salvatuamor2018@gmail.com"
                  className="hover:text-[#14B8A6] transition-colors cursor-pointer"
                >
                  salvatuamor2018@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-linkedin-box-line text-lg text-[#14B8A6]"></i>
                <a 
                  href="https://www.linkedin.com/in/adriana-muñoz-psicóloga" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-[#14B8A6] transition-colors cursor-pointer"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-300 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-600">
            © {currentYear} Adriana Muñoz. Todos los derechos reservados.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-gray-600 hover:text-[#14B8A6] transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
